import React from 'react';
import { get, toInteger } from 'lodash';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { memberDetailEntitiesWidget as MemberDetailEntitiesWidget} from 'ui/views/widgets/memberDetailEntitiesWidget';
import { MemberDetailsEntitiesWidgetService } from 'services/memberDetailsEntitiesWidget';
import { withRouter } from 'react-router-dom';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsEntitiesWidget } from 'ui/containers/MemberDetailsEntitiesWidget';
 *
 * // render
 * <MemberDetailsEntitiesWidget propName='propValue'/>
 */
class _MemberDetailsEntitiesWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        this.fetchGeneration = 0;
        this.fetchActive = true;

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // Member Detail instance
        this.memberDetailsEntitiesWidgetService = new MemberDetailsEntitiesWidgetService();

        // start member detail data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch member detail information.
     */
    async fetchComponentData() {
        log.debug( 'MemberDetailsEntitiesWidget.fetchComponentData()' );

        const generation = ++this.fetchGeneration;
        // cancel ongoing request
        this.memberDetailsEntitiesWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsEntitiesWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            if( ! this.fetchActive || generation !== this.fetchGeneration ) return;

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } ) : null );
            } else {
                this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } ) : null );
            }

        } catch( e ) {
            if( ! this.fetchActive || generation !== this.fetchGeneration ) return;
            this.setState( () => this.fetchActive && generation === this.fetchGeneration ? ( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } ) : null );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.fetchActive = false;
        this.fetchGeneration++;
        this.memberDetailsEntitiesWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {

        // get active tab index from route state
        const entitiesActiveTabIndex = get( this.props.location, 'state.entitiesActiveTabIndex', 0 );

        return (
            <MemberDetailEntitiesWidget
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                activeTabIndex={ toInteger( entitiesActiveTabIndex ) }
            />
        );
    }
}

// set display name
_MemberDetailsEntitiesWidget.displayName = '_MemberDetailsEntitiesWidget';

// set default props
_MemberDetailsEntitiesWidget.defaultProps = {
    requestPayload: {},
};

// prop types
_MemberDetailsEntitiesWidget.propTypes = {};

/*********************************************/

// wrap with router
export const MemberDetailsEntitiesWidget = withRouter( _MemberDetailsEntitiesWidget );

